import React, { Component } from "react";
import { Nav, NavbarToggler, NavbarBrand } from "reactstrap";
import { DropDownMenu } from "../../components";

import { withRouter } from "react-router-dom";
import { paths } from "../../../../../common/constants";
import connect from "react-redux/es/connect/connect";
import { AWS_STATIC_ENDPOINT } from "../../../../../common/constants";

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageData: {},
    };
  }

  componentDidMount() {
    document.body.classList.toggle("aside-menu-hidden");
  }

  static sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  static sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-minimized");
  }

  static mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  static asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("aside-menu-hidden");
  }

  render() {
    let logoNav = (
      <NavbarBrand
        href={paths.client.ADMIN_CUSTOMERS}
        style={{ backgroundImage: "unset", borderBottom: "none" }}
      >
        <img
          src={AWS_STATIC_ENDPOINT + "/images/share_logo_1.png"}
          style={{ height: "100%", padding: "5px" }}
          alt=""
        />
      </NavbarBrand>
    );

    return (
      <header className="app-header navbar">
        <NavbarToggler
          className="d-lg-none"
          onClick={Header.mobileSidebarToggle}
        >
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
        {logoNav}
        <Nav className="ml-auto profile-view" navbar>
          <DropDownMenu />
        </Nav>
      </header>
    );
  }
}

Header.propTypes = {};

export default Header;



// WEBPACK FOOTER //
// ./client/react/Admin/components/Header/Header.js